import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import style from './faqList.module.scss'
import { VegaHeading } from '../../vega/heading/Heading'
import { FAQItem } from '../item/FAQItem'
import { VegaButton, VegaButtonTypes } from '../../vega/button/Button'
import { PropTypes } from 'prop-types'

/**
 * FAQ section of the payment tracker
 */
const FAQList = ({ className }) => {
	const { t } = useTranslation()

	const [faqList] = useState([
		{ question: 'faqText1Title', answer: 'faqText1Subtitle' },
		{ question: 'faqText2Title', answer: 'faqText2Subtitle' },
		{ question: 'faqText3Title', answer: 'faqText3Subtitle' }
	])

	return (
		<div className={style.faqBox}>
			<div className={style.container}>
				<VegaHeading className={style.title} label={t('faqTitle')} tag="h1" />
				<div>
					{faqList.map((faqItem, index) => (
						<FAQItem
							key={index}
							question={t(faqItem.question)}
							answer={t(faqItem.answer)}
						/>
					))}
				</div>
				<div className={style.buttonContainer}>
					<VegaButton
						type={VegaButtonTypes.OUTLINE}
						label={t('faqGoToHelpcenter')}
						onClick={() => window.open(t('faqGoToHelpcenterHref'))}
					/>
				</div>
			</div>
		</div>
	)
}

FAQList.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string
}

export { FAQList }
